module.exports = __webpack_public_path__ + "static/media/FAQ.4f50eb5e.svg";